import type { AppLanguage } from "./app/language";

const maxAccessLogRetentionDays = 3650;

export const accessLogRetentionDayOptions = [7, 30, 90, 180, 365] as const;

export function normalizeAccessLogRetentionDays(value: unknown, fallback: number | null = null) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const numericValue = typeof value === "number" ? value : Number.parseInt(String(value), 10);

  if (!Number.isFinite(numericValue) || !Number.isInteger(numericValue)) {
    return fallback;
  }

  if (numericValue <= 0 || numericValue > maxAccessLogRetentionDays) {
    return fallback;
  }

  return numericValue;
}

export function formatAccessLogRetentionDaysLabel(days: number, language: AppLanguage = "en") {
  if (language === "ja") {
    if (days === 1) {
      return "1 日";
    }

    if (days % 365 === 0) {
      const years = days / 365;
      return `${years} 年`;
    }

    return `${days} 日`;
  }

  if (days === 1) {
    return "1 day";
  }

  if (days % 365 === 0) {
    const years = days / 365;
    return `${years} year${years === 1 ? "" : "s"}`;
  }

  return `${days} days`;
}